export default __webpack_public_path__ + "favicon-16x16.v2.c9d8ea30842e08f138106a2578b7a8b1.png";